import React from 'react';
import PropTypes from 'prop-types';

/**
 * Grid Component
 * 
 * A flexible grid system built with CSS Grid and Tailwind utilities.
 * Provides responsive layout capabilities for the NuVola design system.
 */

const Grid = ({
  children,
  cols = 1,
  gap = 4,
  responsive = false,
  className = '',
  ...props
}) => {
  // Base grid styles
  const baseStyles = ['grid'];

  // Column configuration
  const getColsClass = () => {
    if (responsive) {
      // Default responsive pattern: 1 col mobile, 2 col tablet, specified cols desktop
      return `grid-cols-1 md:grid-cols-2 lg:grid-cols-${cols}`;
    }
    return `grid-cols-${cols}`;
  };

  // Gap configuration
  const gapClass = `gap-${gap}`;

  // Combine all classes
  const gridClasses = [
    ...baseStyles,
    getColsClass(),
    gapClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={gridClasses} {...props}>
      {children}
    </div>
  );
};

Grid.propTypes = {
  /** Grid content */
  children: PropTypes.node.isRequired,
  
  /** Number of columns */
  cols: PropTypes.number,
  
  /** Gap between grid items */
  gap: PropTypes.number,
  
  /** Enable responsive behavior */
  responsive: PropTypes.bool,
  
  /** Additional CSS classes */
  className: PropTypes.string
};

Grid.defaultProps = {
  cols: 1,
  gap: 4,
  responsive: false,
  className: ''
};

export default Grid; 